/**
 * TBD
 * Product Area: NET_TERMS
 */
export const SPECIAL_HOLIDAY_NET90_TIMEZONE = 'SPECIAL_HOLIDAY_NET90_TIMEZONE';
